import { render, staticRenderFns } from "./go.vue?vue&type=template&id=74513d31&scoped=true&"
import script from "./go.vue?vue&type=script&lang=ts&"
export * from "./go.vue?vue&type=script&lang=ts&"
import style0 from "./go.vue?vue&type=style&index=0&id=74513d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74513d31",
  null
  
)

export default component.exports